import React, { useMemo } from "react";
import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import {
  VO_HIGHLIGHT_REACTIONS,
  groupHighlightReactions,
  highlightFirstName,
} from "./voHighlights";

export default function VoHighlightDialog({
  item,
  selfUserId = 0,
  onClose,
  onReact,
  onSpeak,
  onCafe,
}) {
  const open = Boolean(item?.userId);
  const name = highlightFirstName(item?.userName);
  const mine = Number(item?.userId) === Number(selfUserId);
  const groups = useMemo(() => groupHighlightReactions(item?.reactions), [item?.reactions]);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 800, pb: 0.5 }}>
        {item?.emoji} {item?.label}
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ mt: 1.25, fontSize: "0.95rem", lineHeight: 1.5 }}>
          {item?.copy}
        </Typography>
        {mine ? (
          <Typography sx={{ mt: 1.25, fontSize: "0.8rem", color: "text.secondary" }}>
            O time pode reagir daqui. Câmera continua opcional.
          </Typography>
        ) : (
          <Typography sx={{ mt: 1.25, fontSize: "0.8rem", color: "text.secondary" }}>
            Tímido: manda um emoji. À vontade: abre o microfone — câmera só se quiser.
          </Typography>
        )}
        {groups.length ? (
          <Stack spacing={0.85} sx={{ mt: 1.75 }}>
            {groups.map((group) => (
              <Stack
                key={group.emoji}
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ minWidth: 0 }}
              >
                <Typography sx={{ fontSize: "1.15rem", lineHeight: 1 }}>{group.emoji}</Typography>
                <Stack direction="row" spacing={-0.6} sx={{ pr: 0.5 }}>
                  {group.people.slice(0, 4).map((person) => (
                    <Avatar
                      key={`${group.emoji}-${person.fromUserId}`}
                      src={person.fromPhoto || undefined}
                      alt={person.fromName || "Colega"}
                      sx={{
                        width: 22,
                        height: 22,
                        fontSize: "0.62rem",
                        bgcolor: "#e8c48a",
                        color: "#3a2414",
                        border: "1px solid #fff",
                      }}
                    >
                      {highlightFirstName(person.fromName, "?").slice(0, 1)}
                    </Avatar>
                  ))}
                </Stack>
                <Typography
                  sx={{
                    fontSize: "0.78rem",
                    color: "text.secondary",
                    minWidth: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {group.people
                    .map((person) =>
                      Number(person.fromUserId) === Number(selfUserId)
                        ? "Você"
                        : highlightFirstName(person.fromName)
                    )
                    .join(", ")}
                </Typography>
              </Stack>
            ))}
          </Stack>
        ) : null}
        <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap sx={{ mt: 1.75 }}>
          {VO_HIGHLIGHT_REACTIONS.map((emoji) => (
            <Button
              key={emoji}
              onClick={() => onReact?.(emoji, item)}
              sx={{ minWidth: 44, fontSize: "1.15rem" }}
            >
              {emoji}
            </Button>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, flexWrap: "wrap", gap: 1 }}>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>
          Fechar
        </Button>
        {!mine ? (
          <>
            <Button
              onClick={() => onCafe?.(item)}
              sx={{ textTransform: "none", fontWeight: 700 }}
            >
              Puxar um café
            </Button>
            <Button
              variant="contained"
              onClick={() => onSpeak?.(item)}
              sx={{
                textTransform: "none",
                fontWeight: 800,
                bgcolor: "#e8c48a",
                color: "#3a2414",
                "&:hover": { bgcolor: "#f3d7a8" },
              }}
            >
              Falar com {name}
            </Button>
          </>
        ) : null}
      </DialogActions>
    </Dialog>
  );
}
